const DEFAULT_MODE = process.env.NODE_ENV === 'production' ? 'production' : 'test';
export const APP_MODE = process.env.REACT_APP_APP_MODE || DEFAULT_MODE; // 'test' or 'production'

const TEST_API_URL = process.env.REACT_APP_TEST_API_URL || 'http://localhost:5001';
const PRODUCTION_API_URL =
  process.env.REACT_APP_PRODUCTION_API_URL || 'https://flyingbasket-calc-app-production.up.railway.app';

const API_URL_BY_MODE = {
  test: TEST_API_URL,
  production: PRODUCTION_API_URL
};

if (!API_URL_BY_MODE[APP_MODE]) {
  throw new Error(`Invalid APP_MODE "${APP_MODE}". Use "test" or "production".`);
}

// Backward compatibility with previous single-url env.
export const API_BASE_URL = process.env.REACT_APP_API_URL || API_URL_BY_MODE[APP_MODE];
